export default __webpack_public_path__ + "static/media/transfacil_galery_12.8f72d7c6.jpg";